import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import type { DirtyConfirmationOptions } from 'components/Drawers/standardDrawerContract';
import type { DialogAlert } from 'components/QDialogs/types';

import type { ScheduledTransactionEditDialogProps } from './types';

export const DIALOG_TYPE = 'SCHEDULED_TRANSACTION_DIALOG';
export const SCHEDULED_TRANSACTION_DIRTY_CONFIRMATION: DirtyConfirmationOptions = {
  title: 'Just checking...',
  content: 'Are you sure you want to discard all changes?',
  confirmLabel: 'Discard',
  denyLabel: 'Go Back',
};

export const showScheduledTransactionEditDialog = createAction(
  rootUiActions.createDialog.toString(),
  (props: ScheduledTransactionEditDialogProps) => {
    const normalizedProps = props.rootModalDrawer
      ? {
          ...props,
          rootModalDrawer: {
            ...props.rootModalDrawer,
            dirtyConfirmation: props.rootModalDrawer.dirtyConfirmation ?? SCHEDULED_TRANSACTION_DIRTY_CONFIRMATION,
          },
        }
      : props;

    return rootUiTypes.mkRootUiData({
      id: DIALOG_TYPE,
      type: DIALOG_TYPE,
      props: ImmutableMap(normalizedProps),
    });
  },
);

export const closeScheduledTransactionEditDialog = createAction(
  rootUiActions.removeDialog.toString(),
  () => DIALOG_TYPE,
);

export const showConfirmationIfDirty =
  (dialogAlert: DialogAlert, closing?: () => void, cleanup?: () => void) =>
  (confirmIfDirty?: boolean, forceClose?: boolean) => {
    const close = () => {
      cleanup?.();
      closing?.();
    };

    if (forceClose || !confirmIfDirty) {
      close();
      return;
    }

    dialogAlert(
      'Just checking...',
      'Are you sure you want to discard all changes?',
      (btnObj: { btnPressed: string }) => {
        if (btnObj.btnPressed === 'Discard') {
          close();
        }
      },
      ['Go Back', 'Discard'],
    );
  };
